import { render, staticRenderFns } from "./delivery-tenstreet.vue?vue&type=template&id=77c3511e"
import script from "./delivery-tenstreet.vue?vue&type=script&lang=js"
export * from "./delivery-tenstreet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports